import React from 'react';
import { FieldProps, FormattedDateField, useFieldHelper } from 'framework/ui/field';
import { BUDGET_SOURCE } from 'domain/shared/newProject';
import { DATE_FORMAT } from 'framework/utils';

const BudgetDateField = ({ source, date, fallbackDate, sowDate, tempDate, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: dateValue } = useFieldHelper({ source: date });
  const { getValue: sowDateValue } = useFieldHelper({ source: sowDate });
  const primaryDateValue = dateValue();
  const sowValue = sowDateValue();

  const dateSource = primaryDateValue ? date : fallbackDate;

  return (
    <FormattedDateField
      {...props}
      source={getValue() === BUDGET_SOURCE.SOW ? (sowValue ? sowDate : tempDate) : dateSource}
      format={DATE_FORMAT.INPUT_VALUE}
    />
  );
};
export default BudgetDateField;
